export default __webpack_public_path__ + "static/media/Sài Gòn Bank.efe2d836.png";